import React, { useContext, useState, useEffect } from 'react';
import Chart from 'chart.js/auto';
import styled from 'styled-components';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as XLSX from 'xlsx';

import '../../index.css';
import Title from '../../components/Title';
import { getPurchaseInductionRateByContents } from '../../modules/NetworkFunction';
import StatisticsModal from './StatisticsModal';
import AuthContext from '../../contexts/AuthContext';

Chart.register(ChartDataLabels);
const CHART_COLORS = ['#FF650E', '#FF7A00', '#FFA800'];

function PurchaseInduceRate() {
  const { auth: token } = useContext(AuthContext);
  const userNo = window.sessionStorage.getItem('userNo');
  const [allContents, setAllContents] = React.useState([]);
  const [top3Contents, setTop3contents] = React.useState([]);
  const [isProductLoaded, setIsProductLoaded] = React.useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    if (!isProductLoaded) {
      getPurchaseInductionRateByContents(
        { userNo: userNo },
        (d) => {
          setAllContents(d.contents);
          const top3Result = d.contents.slice(0, 3);
          if (top3Result.length < 3) {
            for (let i = top3Result.length; i < 3; i++) {
              top3Result.push({
                contentsNo: '-',
                title: '데이터 존재하지 않음',
                totalSlideView: '-',
                totalItemView: '-',
                purchaseInductionRate: '-',
              });
            }
          }
          setTop3contents(top3Result);
        },
        setIsProductLoaded,
        (err) => {
          console.log(err);
        },
        token
      );
    }
  }, [token, userNo, isProductLoaded]);

  useEffect(() => {
    const ctx = document.getElementById('chart').getContext('2d');

    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: top3Contents.map((c) => {
          return c.title;
        }),
        datasets: [
          {
            axis: 'y',
            data: top3Contents.map((c) => {
              const data =
                c.purchaseInductionRate === '-' ? 0 : c.purchaseInductionRate;
              return data;
            }),
            backgroundColor: CHART_COLORS,
            borderColor: CHART_COLORS,
            borderRadius: 2,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            color: '#fff',
            anchor: 'end',
            align: 'start',
            fontWeight: 500,
            display: function (context) {
              return context.dataset.data[context.dataIndex] !== 0;
            },
          },
        },
        indexAxis: 'y',
        responsive: true,
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          x: {
            display: false,
          },
          y: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                size: 14,
              },
              color: '#4D4D4D',
            },
          },
        },
        layout: {
          padding: {
            left: 80,
            right: 30,
            top: 30,
            bottom: 30,
          },
        },
      },
    });
    return () => {
      chart.destroy();
    };
  }, [top3Contents]);

  const makeExcel_purchaseInduceRate = () => {
    if (allContents.length === 0) {
      alert('조회된 콘텐츠가 없어 빈 엑셀 파일을 생성합니다.');
    }

    const wsData = [];
    const header = ['순위', '콘텐츠명', '슬라이드 조회 수', '제품 조회 수', '구매 유도율'];
    wsData.push(header);

    if (allContents.length === 0) {
      wsData.push(['-', '-', '-', '-', '-']);
    } else {
      for (let i = 0; i < allContents.length; i++) {
        wsData.push([
          i + 1,
          allContents[i].title,
          allContents[i].totalSlideView,
          allContents[i].totalItemView,
          allContents[i].purchaseInductionRate,
        ]);
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '구매 유도율');

    XLSX.writeFile(workbook, '콘텐츠별 구매 유도율.xlsx');
  };

  return (
    <div>
      <StatisticsModal
        open={modalOpen}
        close={closeModal}
        header="구매 유도율"
      />
      <Title title="구매 유도율" />
      <div className="inner-box">
        <p
          style={{
            textAlign: 'center',
            marginTop: 50,
            fontWeight: 500,
            fontSize: 24,
          }}
        >
          콘텐츠별 구매 유도율
        </p>
        <p
          style={{ textAlign: 'center', margin: '16px 0px 50px', fontSize: 18 }}
        >
          월별 TOP 3
        </p>
        <p
          style={{
            textAlign: 'end',
            marginRight: 49,
            color: '#B5B5B5',
            fontSize: 12,
            marginBottom: 9,
          }}
        >
          * 구매 유도율 : 슬라이드 조회 수 대비 특정 상품 상세페이지 조회수
        </p>
        <canvas
          style={{
            margin: 'auto',
            marginBottom: 30,
            backgroundColor: '#F8F8F8',
            borderRadius: 22,
          }}
          id="chart"
          width="670"
          height="162"
        ></canvas>
        <Table>
          <TableRow>
            <TableHeader>순위</TableHeader>
            <TableHeader style={{ width: 200 }}>콘텐츠명</TableHeader>
            <TableHeader>
              슬라이드
              <br />
              조회 수
            </TableHeader>
            <TableHeader>
              제품 <br />
              조회 수
            </TableHeader>
            <TableHeader>
              구매
              <br />
              유도율
            </TableHeader>
          </TableRow>
          {top3Contents.map((contents, idx) => {
            return (
              <div key={idx}>
                <Line></Line>
                <TableRow>
                  <TableData>
                    <Circle>{idx + 1}</Circle>
                  </TableData>
                  <TableData style={{ width: 200 }}>{contents.title}</TableData>
                  <TableData>{contents.totalSlideView}</TableData>
                  <TableData>{contents.totalItemView}</TableData>
                  <TableData style={{ color: '#FFB600', fontWeight: 500 }}>
                    {contents.purchaseInductionRate}
                  </TableData>
                </TableRow>
              </div>
            );
          })}
        </Table>
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            marginTop: '20px',
          }}
        >
          <span
            style={{
              color: '#FF7A00',
              fontWeight: 'bold',
              marginTop: '10px',
              paddingRight: '10px',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              console.log('상품 순위');
              openModal();
            }}
          >
            예시 결과 보기
          </span>
          <span
            style={{
              color: '#FF7A00',
              fontWeight: 'bold',
              marginTop: '10px',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              makeExcel_purchaseInduceRate();
            }}
          >
            전체 내역 다운 받기
          </span>
        </div>
      </div>
    </div>
  );
}

export default PurchaseInduceRate;

const Table = styled.div`
  width: 670px;
  height: 230px;
  border-radius: 8px;
  border: 1px solid #c4c4c4;
  margin: auto;
  padding: 0 15px;
`;

const TableHeader = styled.div`
  font-size: 14px;
  color: #848484;
  width: 80px;
`;

const TableRow = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  height: 55px;
`;

const TableData = styled.div`
  font-size: 16px;
  width: 80px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #c4c4c4;
`;

const Circle = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #b5b5b5;
  margin: auto;
  color: #fff;
  font-size: 18px;
`;
